<h2 mat-dialog-title>{{ 'FRONTEND.BUSINESSES.MEDIA_TAB.IMAGE_MENU.IMAGE_UPDATE_TITLE' | translate }}</h2>
<mat-dialog-content>
  {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.IMAGE_MENU.IMAGE_UPDATE_BODY' | translate }}
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
  <button mat-button color="primary" (click)="onCancel()" type="button" mat-dialog-close>
    {{ 'FRONTEND.BUSINESSES.CANCEL' | translate }}
  </button>
  <business-media-image-uploader
    [buttonText]="buttonText"
    [aspectRatio]="ratio"
    (imageChanged)="onImageChanged($event)"
  >
  </business-media-image-uploader>
</mat-dialog-actions>
